<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-t-title">
      {{$t('maintenance.threats.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-t-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-t-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-t-name-label">
                  {{ $t('maintenance.threats.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-t-form-name"
                  type="text"
                  v-model="tForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.threats.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-t-description-label">
                  {{ $t('maintenance.threats.create.description_label') }}
                </label>
                <b-form-textarea
                  qid="create-t-form-description"
                  v-model="tForm.description"
                  rows="6"
                  max-rows="6"
                  required
                  :placeholder="$t('maintenance.threats.create.description_placeholder')"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('maintenance.threats.create.actor_label') }}
                </label>
                <multiselect
                    v-model="selectedActors"
                    :options="actors"
                    :multiple="true"
                    :taggable="true"
                    track-by="name"
                    :tagPlaceholder="$t('maintenance.threats.create.actor_dropdown_label')"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('maintenance.threats.create.actor_placeholder')"
                    label="name"
                    qid="create-do-tags-select"
                    @search-change="loadActors"
                    @tag="addActor"
                ></multiselect>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-t-cancel-button"
              >
                {{ $t('maintenance.threats.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-t-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.threats.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: 'CreateThreat',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.threats.title'),
            to: '/maintenance/threats'
          },
          {
            text: this.$t('maintenance.threats.create.title'),
            active: true
          }
        ],
        tForm: {
          name: '',
          description: '',
          client:'',
        },
        error: '',
        inputLink: '',
        selectedFiles: [],
        timeLimitItems: [],
        timeLimitInput: '',
        buttonDisabled: false,
        actors: [],
        selectedActors: [],
        newActors: [],
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadActors()
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/threats')
      },
      addActor(newActor) {
        const actor = {
          name: newActor,
          translatable: newActor,
          name_translated: newActor
        }
        this.selectedActors.push(actor)
        this.newActors.push(actor)
      },
      formSubmit(evt) {
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedActors && this.selectedActors.length) {
          for (var i = 0; i < this.selectedActors.length; i++) {
            formData.append("actors[]", this.selectedActors[i].name);
          }
        }

        formData.append("name", this.tForm.name);
        formData.append("description", this.tForm.description);
        formData.append("client", this.getClient.slug);

        this.buttonDisabled = true;

        if (this.selectedActors && this.selectedActors.length) {
          // Post FormData object to API
          piincHttp.post('/threats', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('maintenance.threats.create.success'))
            self.buttonDisabled = false;
            self.goToList();
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = this.$t('maintenance.threats.create.actors_required')
          this.buttonDisabled = false;
        }
      },
      loadActors(query) {
        let self = this;
        piincHttp.get('actors', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.actors = response.data.items
          for (var i = 0; i < self.newActors.length; i++) {
            self.actors.push(self.newActors[i]);
          }
          if (self.actors && !self.actors.length && !query) {
            self.actors.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
    },
    components: {

    },
    created () {
      if (this.getClient && this.getClient.slug) {
        this.loadActors();
      }
    }
  }
</script>
